import { useState } from 'react'

import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import InputsWithoutValidate from 'Components/UI/Molecules/InputsWithoutValidate'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import { interfaces } from 'service/interfaces'

import { fieldsAdd } from './fields'

const AddItem = (props) => {
  const { open, handleClose, render, setRender, dataInfo, setRows } = props

  const createDismissableSnackbar = useCustomSnackbar()

  const [isLoading, setIsLoading] = useState(false)
  const [info, setInfo] = useState({
    empresa: dataInfo.cajaInfo.origen,
    fecha: dataInfo.cajaInfo.fecha,
    sucursal: dataInfo.cajaInfo.sucursal,
    tipo: 'Efectivo',
    nombre: null,
    factura: null,
    descripcion: null,
    importe: null,
  })

  const handleChange = (name, value) => {
    setInfo((prevInfo) => ({
      ...prevInfo,
      [name]: value,
    }))
  }

  function _renderStepContent() {
    return <InputsWithoutValidate fields={fieldsAdd(info, handleChange)} spacing={2} />
  }

  const addProducts = async () => {
    setIsLoading(true)
    const [dia, mes, año] = info.fecha.split('/')
    const fechaFormateada = `${año}-${mes}-${dia}`
    const body = {
      ...info,
      tipo: 1,
      fecha: fechaFormateada,
    }

    await interfaces.salesCaja
      .addGasto(body)
      .then((res) => {
        setRows((prevRows) => [...prevRows, { ...info }])
        // setData((prevData) => ({
        //   ...prevData,
        //   cajas: [...prevData.cajas, { ...info }],
        // }))
        setRender(!render)
        createDismissableSnackbar(res.data, {
          variant: 'success',
        })
      })
      .catch(() => {
        createDismissableSnackbar('Error', {
          variant: 'error',
        })
      })
    setIsLoading(false)
    handleClose()
  }

  const isSubmitDisabled = () => {
    const hasNombre = info.nombre && info.nombre.toString().trim() !== ''
    const hasDescripcion = info.descripcion && info.descripcion.toString().trim() !== ''
    const hasImporte = info.importe !== null && info.importe !== undefined && info.importe !== ''

    return !hasNombre || !hasDescripcion || !hasImporte
  }

  return (
    <DialogComponent
      title="Cargar gasto"
      open={open}
      handleclose={handleClose}
      handleclosedisabled={isLoading}
      widthLarge="500px"
      disableBackdropClick
      disableEscapeKeyDown
      maxHeight
      children={
        <>
          <div>{_renderStepContent()}</div>
        </>
      }
      actions={
        <CancelConfirmButtons
          disabledSubmit={isLoading || isSubmitDisabled()}
          disabledCancel={isLoading}
          isLoading={isLoading}
          onClickSubmit={addProducts}
          onClickCancel={handleClose}
        />
      }
    />
  )
}
export default AddItem
